module.exports = __webpack_public_path__ + "img/album14_36.875e4ebf.jpg";